module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.b1a9c3a92d7fe46449a6.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module chunks = styles